import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HomeService } from '../_services/home.service';
import { ChangeDetectorRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ProfileService } from '../_services/profile.service';
import { Router } from '@angular/router';
import { ErrorMessageService } from '../services/error-message.service';
import Swal from 'sweetalert2';
import { environmentbasic } from '../../environments/environment-basic';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-profileupdate',
  templateUrl: './profileupdate.component.html',
  styleUrls: ['./profileupdate.component.scss']
})
export class ProfileUpdateComponent implements OnInit {
  profileForm!: FormGroup;
  step = 1;
  // birthYears: number[] = [];
  selectedFileNames: string[] = [];
  imageItems: { loading: boolean; purpose: string }[] = [];
  uploadedImages: string[] = [];
  profileid: any;
  fullname: any;

  panDocument: string = '';
  aadharDocument: string = '';
  officeIdDocument: string = '';
  constructor(private fb: FormBuilder, private homeService: HomeService, private cdr: ChangeDetectorRef,
    private profileService: ProfileService, private router: Router, private errorMessageService: ErrorMessageService, private sanitizer: DomSanitizer
  ) { }
  birthYears: number[] = [];

  ngOnInit(): void {
    const profileid2 = localStorage.getItem('UserProfile')
    const profileid1 = JSON.parse(profileid2)
    const profileids = JSON.parse(profileid2)
    this.profileid = profileids.payload?.payload?.id ?? profileids.payload?.id;
    this.fullname = profileids.payload?.payload?.fullName ?? profileids.payload?.fullName;
    this.getProfileById(this.profileid)

    this.searchCity();
    this.searchCitycom();
    const currentYear = new Date().getFullYear();
    this.birthYears = Array.from({ length: 60 }, (_, i) => currentYear - i);

    this.profileForm = this.fb.group({
      fullName: [''],
      lastName: [''],
      email: [''],
      mobileNumber: [''],
      gender: [''],
      birthYear: [''],
      address: [''],
      locality: [''],
      cityId: [''],
      stateId: [''],
      pincode: [''],
      companyProfession: [''],
      companyName: [''],
      companyAddress: [''],
      companyLocality: [''],
      companyCityId: [''],
      companyStateId: [''],
      companyPincode: [''],
      officeIdNumber: [''],
      aadharNumber: [''],
      panNumber: [''],
      panDocument: [''],
      aadharDocument: [''],
      officeIdDocument: [''],
      adminLogo: [''],
      userType: ['User'],
      deleteAccount: [0],
      accountEnabled: [1],
      productUser: ['estate'],
      individual: [true]

    });
  }
  getProfileById(profileid) {
    this.profileService.getProfileById(profileid).subscribe(
      response => {
        if (response['status'] === 'SUCCESS') {
          const parsedProfileData = response['payload'];
          localStorage.setItem('UserProfile', JSON.stringify({ payload: parsedProfileData }));

          this.profileForm.patchValue(parsedProfileData);
          this.profileImageUrl = parsedProfileData?.adminLogo
          this.panDocument = parsedProfileData?.panDocument
          this.aadharDocument = parsedProfileData?.aadharDocument
          this.officeIdDocument = parsedProfileData?.officeIdDocument


          this.stateList = [{
            stateId: parsedProfileData.stateId,
            stateName: parsedProfileData.stateName
          }];
          this.profileForm.patchValue({
            cityId: parsedProfileData.cityData.id,
            cityName: parsedProfileData.cityData.name,
            stateId: parsedProfileData.stateId
          });

          this.stateListcom = [{
            companyStateId: parsedProfileData.companyStateId,
            compamnystateName: parsedProfileData.companyStateName
          }];
          this.profileForm.patchValue({
            companyCityId: parsedProfileData.companyCityId,
            companyStateId: parsedProfileData.companyStateId
          });

          if (parsedProfileData.panDocument) {
            this.selectedPanFileName = this.extractFileName(parsedProfileData.panDocument);
            this.selectedPanFileUrl = this.sanitizer.bypassSecurityTrustUrl(parsedProfileData.panDocument);
          }

          if (parsedProfileData.aadharDocument) {
            this.selectedAadharFileName = this.extractFileName(parsedProfileData.aadharDocument);
            this.selectedAadharFileUrl = this.sanitizer.bypassSecurityTrustUrl(parsedProfileData.aadharDocument);
          }

          if (parsedProfileData.officeIdDocument) {
            this.selectedOfficeIdFileName = this.extractFileName(parsedProfileData.officeIdDocument);
            this.selectedOfficeIdFileUrl = this.sanitizer.bypassSecurityTrustUrl(parsedProfileData.officeIdDocument);
          }

        }
      },
      error => {
        console.error('Error updating profile:', error);
      }
    );
  }
  extractFileName(url: string): string {
    return url.substring(url.lastIndexOf('/') + 1);
  }



  prevStep() {
    if (this.step > 1) {
      this.step--;
    }
  }
  nextStep() {
    if (this.step < 4) {
      this.step++;
    }
  }
  submitForm() {
    if (this.profileForm.valid) {
      const formValues = this.profileForm.value;

      const payload = {
        ...formValues,
        birthYear: Number(formValues.birthYear),
        panDocument: this.panDocument || null,
        aadharDocument: this.aadharDocument || null,
        officeIdDocument: this.officeIdDocument || null,
        adminLogo: this.profileImageUrl || null,
        individual: true
      };

      console.log('Final Payload:', payload);

      this.profileService.updateprofile(payload).subscribe(
        (response: any) => {
          if (response.status === 'SUCCESS') {
            console.log('Profile updated successfully!');

            // Step 1: Update "auth-user" in localStorage
            const existingUser = JSON.parse(localStorage.getItem('auth-user') || '{}');
            const updatedProfileData = {
              ...existingUser,
              ...payload
            };
            localStorage.setItem('auth-user', JSON.stringify(updatedProfileData));

            // Step 2: Fetch updated full profile and store it
            this.profileService.getProfileById(this.profileid).subscribe((res: any) => {
              if (res.status === 'SUCCESS') {
                const updatedFullProfile = { payload: res.payload };
                localStorage.setItem('UserProfile', JSON.stringify(updatedFullProfile));
              }
            });

            // Step 3: Show success alert
            Swal.fire({
              icon: 'success',
              title: 'Profile updated successfully!',
              showConfirmButton: false,
              timer: environmentbasic.timer
            });

            // Step 4: Refresh current route after alert disappears
            setTimeout(() => {
              const currentUrl = this.router.url;
              this.router.routeReuseStrategy.shouldReuseRoute = () => false;
              this.router.onSameUrlNavigation = 'reload';
              this.router.navigate([currentUrl]);
            }, environmentbasic.timer); // same delay as Swal alert

          } else if (response.message) {
            const errorMessage = this.errorMessageService.getErrorMessage(response.message);
            Swal.fire({
              icon: 'error',
              title: errorMessage,
              showConfirmButton: false,
              timer: environmentbasic.timer
            });
          }
        },
        error => {
          console.error('Error updating profile:', error);
          Swal.fire({
            icon: 'error',
            title: 'Something went wrong while updating the profile!',
            showConfirmButton: false,
            timer: environmentbasic.timer
          });
        }
      );


    } else {
      this.profileForm.markAllAsTouched();
    }
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, ''); // Remove any non-digit characters
    if (input.value.length > 10) {
      input.value = input.value.slice(0, 10); // Limit to 10 digits
    }
  }
  onAdhar(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
    if (input.value.length > 12) {
      input.value = input.value.slice(0, 12);
    }
  }
  isSellSelected: boolean = false;
  isresiSelected: boolean = false;
  isconSelected: boolean = false;
  selectedCityId: string | null = null;
  searchCityQuery: string = 'Gurgaon';
  cityDataList: any[] = [];
  stateList: any[] = [];
  selectedStateId: string | null = null;
  onSearchCity(event: { term: string }) {
    const searchTerm = event.term || '';
    this.searchCity(searchTerm);
  }

  searchCity(searchTerm: string = '') {
    if (this.selectedCityId) {
      this.selectedCityId = null;
      this.searchCityQuery = searchTerm;
    }

    this.homeService.searchCity(searchTerm).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          this.cityDataList = response.payload;

        }
      },
      (error) => {
        console.error('Failed to fetch cities', error);
      }
    );
  }

  onCitySelected(selectedCity: any) {
    console.log('Selected city object:', selectedCity);
    if (selectedCity && selectedCity.id) {
      this.stateList = [{
        stateId: selectedCity.stateId,
        stateName: selectedCity.stateName
      }];
      this.profileForm.patchValue({
        cityId: selectedCity.id,
        cityName: selectedCity.name,
        stateId: selectedCity.stateId
      });
    } else {
      console.warn('Invalid city object selected:', selectedCity);
    }
  }


  isSellSelectedcom: boolean = false;
  isresiSelectedcom: boolean = false;
  isconSelectedcom: boolean = false;
  selectedCityIdcom: string | null = null;
  searchCityQuerycom: string = 'Gurgaon';
  cityDataListcom: any[] = [];
  stateListcom: any[] = [];
  selectedStateIdcom: string | null = null;
  onSearchCitycom(event: { term: string }) {
    const searchTerm = event.term || '';
    this.searchCitycom(searchTerm);
  }

  searchCitycom(searchTerm: string = '') {
    if (this.selectedCityId) {
      this.selectedCityId = null;
      this.searchCityQuery = searchTerm;
    }

    this.homeService.searchCity(searchTerm).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          this.cityDataListcom = response.payload;

        }
      },
      (error) => {
        console.error('Failed to fetch cities', error);
      }
    );
  }

  onCitySelectedcom(selectedCitycom: any) {
    console.log('Selected city object:', selectedCitycom);
    if (selectedCitycom && selectedCitycom.id) {
      this.stateListcom = [{
        companyStateId: selectedCitycom.stateId,
        compamnystateName: selectedCitycom.stateName
      }];
      this.profileForm.patchValue({
        companyCityId: selectedCitycom.id,
        companyStateId: selectedCitycom.stateId
      });
    } else {
      console.warn('Invalid city object selected:', selectedCitycom);
    }
  }
  selectedFiles: { file: File; docType: 'panDocument' | 'aadharDocument' | 'officeIdDocument' }[] = [];
  selectedPanFileName: string = '';
  selectedAadharFileName: string = '';
  selectedOfficeIdFileName: string = '';
  selectedPanFileUrl: SafeUrl | null = null;
  selectedAadharFileUrl: SafeUrl | null = null;
  selectedOfficeIdFileUrl: SafeUrl | null = null;
  handleChange(event: any, docType: 'panDocument' | 'aadharDocument' | 'officeIdDocument'): void {
    const files = event.target.files;
    if (files && files.length) {
      const file = files[0];  // assume one file only
      const index = this.imageItems.length;
      this.imageItems.push({ loading: true, purpose: 'userDocument' });
      this.uploadSingleFile(file, docType, index);
      const objectUrl = URL.createObjectURL(file);
      if (docType === 'panDocument') {
        this.selectedPanFileName = file.name;
        this.selectedPanFileUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
      }

      if (docType === 'aadharDocument') {
        this.selectedAadharFileName = file.name;
        this.selectedAadharFileUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
      }

      if (docType === 'officeIdDocument') {
        this.selectedOfficeIdFileName = file.name;

        this.selectedOfficeIdFileUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);  // ✅ Sanitize
      }
      this.cdr.detectChanges();
      this.clearFileInput();
    }
  }


  uploadSingleFile(file: File, docType: 'panDocument' | 'aadharDocument' | 'officeIdDocument', index: number): void {
    const mimeType = file.type;
    const purpose = 'userDocument';

    this.imageItems[index].loading = true;

    this.homeService.getMediaData(purpose, mimeType, file)
      .pipe(finalize(() => {
        this.imageItems[index].loading = false;
        this.cdr.detectChanges();
      }))
      .subscribe((res: any) => {
        const url = res.url;

        if (docType === 'panDocument') this.panDocument = url;
        if (docType === 'aadharDocument') this.aadharDocument = url;
        if (docType === 'officeIdDocument') this.officeIdDocument = url;

        this.uploadedImages.push(url);
        this.cdr.detectChanges();
      });
  }


  clearFileInput(): void {
    const fileInputs = document.querySelectorAll('input[type="file"]');
    fileInputs.forEach(input => {
      (input as HTMLInputElement).value = '';
    });
  }

  @ViewChild('profileFileInput') profileFileInput!: ElementRef<HTMLInputElement>;

  profileImageUrl: string | null = null;

  triggerProfileUpload(): void {
    this.profileFileInput.nativeElement.click();
  }

  onProfileImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const mimeType = file.type;
      const purpose = 'userDocument'; // Reuse same purpose if required

      // Preview the selected image
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.profileImageUrl = e.target.result;
      };
      reader.readAsDataURL(file);

      // Reuse existing getMediaData call
      this.homeService.getMediaData(purpose, mimeType, file).subscribe(
        (res: any) => {
          const uploadedUrl = res.url;
          this.profileImageUrl = uploadedUrl; // use actual uploaded URL if preferred
          console.log('Profile uploaded at:', uploadedUrl);
        },
        error => {
          console.error('Upload error:', error);
        }
      );
    }
  }


  getFormattedFileName(label: string, fileName: string): string {
    if (!fileName) return '';
    const ext = fileName.split('.').pop();
    if (!ext || ext === fileName) return label; // no extension found
    return `${label}.${ext.toLowerCase()}`;
  }






}
